import { isLightColor } from '@hotjar/common';

/**
 * Analyzes whether a color is dark or light.
 *
 * @param color The rgb color to analyze, e.g. "rgb(255,0,0)" or "#FF0000".
 * @param opposite Return the opposite color type.
 * @param threshold Threshold at which brightness color is considered light or dark
 * @returns {*} 'light' or 'dark'.
 */
export function isDarkOrLight(
  color: string,
  opposite = false,
  threshold?: number,
): 'dark' | 'light' {
  const isLight = isLightColor(color, threshold);
  if (opposite) return isLight ? 'dark' : 'light';
  return isLight ? 'light' : 'dark';
}
